if ((document.documentElement.lang =="fr") || (window.location.href.indexOf("solestar.com/fr")) > -1 || (window.location.href.indexOf("solestar.de/fr")) > -1) {
  
  const headers = document.querySelectorAll('h3');
                                     
  headers.forEach(header => {
    
    // removes policy 22. for /fr 
    if (header.innerHTML.includes('22.')) {
      const p1 = header.nextSibling;
      const p2 = p1.nextSibling;
      
      header.parentElement.removeChild(header);
      p1.parentElement.removeChild(p1);
      p2.parentElement.removeChild(p2);
    }
  });
  
  // because the policy 22. is remove, the remaining policy positions need to be updated
  for (let i = 22; i < headers.length; i++) {
    headers[i].innerHTML = headers[i].innerHTML.replace(`${i+1}`, `${i}`);
  }
  
}

